
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign-up",
      function () {
        return require("private-next-pages/auth/sign-up.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/sign-up"])
      });
    }
  